import { Station } from '@app/core/types/stations';

export function isDiarizationSegmentsEnabled(station: Station) {
  return (
    Boolean(station.featuresConfig?.transcription?.enabled) &&
    Boolean(station.featuresConfig?.transcription?.diarization?.segments)
  );
}
